import { useAuthContext } from '../../auth';
import { routes } from '../../routes';
import { Link } from 'react-router-dom';
import { Wordmark } from './Wordmark';

type HeaderProps = {
  visible?: boolean;
};

export const Header = ({ visible = true }: HeaderProps) => {
  const { user } = useAuthContext();

  return (
    <header
      className={`
        fixed top-0 left-0 right-0 z-50 px-6 py-4
        transition-all duration-300
        ${visible
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 -translate-y-full pointer-events-none'
        }
      `}
      style={{ transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)' }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between px-6 py-3 rounded-2xl bg-white/80 backdrop-blur-lg border border-gray-200/50 shadow-lg shadow-gray-900/5">
          {/* Logo */}
          <Link to="/">
            <Wordmark className="h-7 w-auto" />
          </Link>

          {/* CTA */}
          {user ? (
            <Link
              to="/orgs"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-blue-600 text-white font-medium text-sm hover:bg-blue-700 transition-colors"
            >
              Dashboard
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          ) : (
            <Link
              to={routes.login.getPath()}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-gray-900 text-white font-medium text-sm hover:bg-gray-800 transition-colors"
            >
              Get Started
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};
